import { Icon, IconName } from '@talos/kyoko';

type FavoriteToggleIconProps = Omit<React.ComponentProps<typeof Icon>, 'icon' | 'onClick'> & {
  'data-testid'?: string;
  isFavorite: boolean;
  onToggle: () => void;
};

export function FavoriteToggleIcon({
  isFavorite,
  onToggle,
  size = 'fontSizeLarge',
  className,
  'data-testid': dataTestId = 'favorite-toggle',
  p = 'spacing12',
  spaceBefore = '-spacing12',
  style,
  ...rest
}: FavoriteToggleIconProps) {
  return (
    <Icon
      icon={isFavorite ? IconName.StarSolid : IconName.Star}
      color={isFavorite ? 'yellow.lighten' : 'gray.080'}
      size={size}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();
        onToggle();
      }}
      p={p}
      spaceBefore={spaceBefore}
      className={className}
      data-testid={dataTestId}
      data-checked={isFavorite}
      style={style}
      {...rest}
    />
  );
}
